export const formatPhoneNumber = (phoneNumber: string): string => {
  const trimmedPhoneNumber = phoneNumber.replace(/\+/g, '');
  const cleanedPhoneNumber = trimmedPhoneNumber.match(/(\d{1})(\d{3})(\d{3})(\d{4})$/);

  if (cleanedPhoneNumber) return `${cleanedPhoneNumber[1]} ${cleanedPhoneNumber[2]} ${cleanedPhoneNumber[3]} ${cleanedPhoneNumber[4]}`;
  return '';
}; 